import { Dispatch } from 'redux';
import { gettingRepaymentStrategyFinish } from 'modules/cm/RepaymentStrategy/store/actions';
import { RepaymentStrategy } from 'modules/cm/RepaymentStrategy/RepaymentStrategy';

const setRepaymentData = (repaymentStrategy: RepaymentStrategy) => {
  return async (dispatch: Dispatch<any>) => {
    dispatch(gettingRepaymentStrategyFinish(repaymentStrategy));
  };
};

export default setRepaymentData;
